import starlinkBg from 'assets/images/starfield_simulation.gif';

export const StarfieldGifSimulation = () => {
  return (
    <img
      src={starlinkBg}
      alt="Starlink Background"
      className="pointer-events-none absolute inset-0 z-0 h-full w-full object-cover opacity-30"
      style={{ imageRendering: 'pixelated' }}
    />
  );
};
